import apiClient from "../core/apiClient";
import { LoginCredentialsDTO, LoginResponse } from "../interfaces/DTO/auth";
import { useAuthStore } from "../stores/authStore";


class LoginService {
  /**
   * התחברות משתמש
   * @param credentials פרטי התחברות
   * @returns תשובת התחברות מהשרת
   */
  async loginUser(credentials: LoginCredentialsDTO): Promise<LoginResponse> {
    try {
      const { data } = await apiClient.post<LoginResponse>("/login", credentials);
  
      // עדכון ה-Store אחרי התחברות מוצלחת
      const setAuthenticated = useAuthStore.getState().setAuthenticated;
      setAuthenticated(true,data.user); // מעדכן את המשתמש ב-store
  
      return data;
    } catch (error) {
      console.error("Login failed:", error);
      throw error;
    }
  }
  

  /**
   * התנתקות משתמש
   */
  async logoutUser(): Promise<void> {
    try {
      // שמירת redirectPath לפני ניקוי
      const redirectPath = useAuthStore.getState().redirectPath;

      // קריאה לשרת למחיקת ה-Token
      await apiClient.post("/login/logout");

      // ניקוי ה-Store המקומי
      const clearAuth = useAuthStore.getState().clearAuth;
      clearAuth();

      // הפניה לדף ההתחברות עם returnUrl אם יש
      if (redirectPath) {
        window.location.href = `/login?returnUrl=${encodeURIComponent(redirectPath)}`;
      } else {
        window.location.href = "/login";
      }
    } catch (error) {
      console.error("Logout failed:", error);

      // במקרה של שגיאה, עדיין ננקה את ה-Store ונפנה ל-Login
      const redirectPath = useAuthStore.getState().redirectPath;
      const clearAuth = useAuthStore.getState().clearAuth;
      clearAuth();

      if (redirectPath) {
        window.location.href = `/login?returnUrl=${encodeURIComponent(redirectPath)}`;
      } else {
        window.location.href = "/login";
      }
    }
  }
}

export const loginService = new LoginService();
